import types from "./types";
import service from "./service";
import swal from "sweetalert";
import { utils } from "../../../utils";

const getSiteOet = (oetID, runID, page) => {
    return (dispatch, getState) => {
        dispatch({ type: types.GET_SITES });
        service
            .getOETSites(oetID, runID, page ? page : getState().oet.site_pagination.actualPage)
            .then(sites => {
                dispatch(getSiteOetSuccess(sites.list));
                dispatch(updateSitesPagination(sites.pagination));
            })
            .catch(error => dispatch(getSiteOetFail(error)));
    };
};

const getOetSSOTI = (oetID, runID, page) => {
    return (dispatch, getState) => {
        dispatch({ type: types.GET_SSOTITEM });
        service
            .getSSOTIOET(oetID, runID, page ? page : getState().oet.ssoti_pagination.actualPage)
            .then(ssoti => {
                dispatch(getOetSSOTISuccess(ssoti.list));
                dispatch(updateSsotiPagination(ssoti.pagination));
            })
            .catch(error => dispatch(getOetSSOTIFail(error)));
    };
};

const createOetIn = (cpoRegisterID, circle, project, onOk = () => {}, onFail = () => {}, stp_number) => {
    return dispatch => {
        dispatch({ type: types.CREATE_OET_IN });
        service
            .createOetIn(cpoRegisterID, circle, project, stp_number)
            .then(oet => dispatch(createOetInSuccess(oet, oet => onOk(oet))))
            .catch(error => dispatch(createOetInFail(error, onFail)));
    };
};

const getOetInDetail = (oetID, history, runID) => {
    return dispatch => {
        dispatch({ type: types.GET_OET_IN_DETAIL });
        const promise = service.getOetInDetail(oetID);
        return updateOETfromPromise(promise, dispatch, history, runID, oetID);
    };
};
const cancelSsotItems = (runID, ids, action, oetID) => {
    return dispatch => {
        dispatch({ type: types.CANCEL_SSOT_ITEMS });
        return service
            .cancelSsotItems(runID, ids, action)
            .then(result => {
                dispatch({ type: types.CANCEL_SSOT_ITEMS_SUCCESS });
                getRunDetail(runID, oetID);
                return result;
            })
            .catch(error => {
                if (error.response) {
                    const status = error.response.status;
                    if (status === 400) {
                        swal({
                            title: "Warning ...",
                            text: `${
                                error.response.data.non_field_errors
                                    ? error.response.data.non_field_errors.join(" \n")
                                    : ""
                            }\n${`${error.response.data.id__in ? error.response.data.id__in.join(" \n") : ""}`}`,
                            icon: "warning",
                            timer: 3000,
                            button: true
                        });
                    }
                }
                dispatch({ type: types.CANCEL_SSOT_ITEMS_FAIL });
            });
    };
};

const changeOETStatus = (oetID, status, history) => {
    return dispatch => {
        const promise = service.passToProjectOet(oetID, status);
        updateOETfromPromise(promise, dispatch, history, null, oetID);
        return promise;
    };
};

const alertSuccessfullyUpdate = oet =>
    swal({
        title: "Successfully updated!",
        text: `OET #${oet.id_zfill} ${oet.name}`,
        icon: "success",
        timer: 3000,
        button: true
    });

const alertFailyUpdate = errors => {
    const mgs = Object.keys(errors)
        .map(key => {
            const mg = errors[key];
            return `${key}: ${mg}`.split("_").join(" ");
        })
        .join("\n");
    swal({
        title: "Warning",
        text: mgs,
        icon: "warning",
        timer: 3000,
        button: true
    });
};

const updateOETItem = (oetID, item, history) => {
    return dispatch => {
        const promise = service.updateOET(oetID, {
            items: [item]
        });
        updateOETfromPromise(promise, dispatch, history, null, oetID);
    };
};

const executeService = (service, props) => {
    return dispatch => {
        dispatch({ type: types.EXECUTE_SERVICE });
        service(...props)
        .then(() => {
            swal({
                title: 'Success',
                text: "Request successfull.",
                icon: 'success',
                button: true
            });
            dispatch({ type: types.EXECUTE_SERVICE_SUCCESS });
        })
        .catch(error => {
            dispatch({ type: types.EXECUTE_SERVICE_FAIL });
            swal({
                title: "Error",
                text: utils.computeError(error),
                icon: "error",
                button: true
            });
            
        });
    };
}

const updateLogistic = (oetID, body, history) => {
    const { bp_open_work_order_ref_number, purchasing_group, name, items, sap_top_wbs } = body;
    return dispatch => {
        const promise = service.updateOET(oetID, {
            bp_open_work_order_ref_number,
            purchasing_group,
            name,
            items,
            sap_top_wbs
        });

        updateOETfromPromise(
            promise,
            dispatch,
            history,
            null,
            oetID,
            oet => alertSuccessfullyUpdate(oet),
            errors => alertFailyUpdate(errors)
        );
    };
};

const updateTCC = (oetID, for_offer_number_created_in_csp, history, runID) => {
    return dispatch => {
        const promise = service.updateOET(oetID, { for_offer_number_created_in_csp });
        updateOETfromPromise(
            promise,
            dispatch,
            history,
            runID,
            oetID,
            oet => {
                alertSuccessfullyUpdate(oet);
                runID && dispatch(getRunDetail(runID, oetID));
            },
            errors => alertFailyUpdate(errors)
        );
    };
};

const updateCPM = (oetID, base_id, history, runID, form = undefined, account_indicator=undefined) => {
    return dispatch => {
        if (!base_id) {
            swal({
                title: "Validation error!",
                text: `The BASE ID is required`,
                icon: "warning",
                timer: 3000,
                button: true
            });
            return;
        }
        const body = {
            account_indicator: account_indicator,
            base_id: base_id,
            run: runID
        }
        const promise = service.updateOET(oetID, body);
        updateOETfromPromise(
            promise,
            dispatch,
            history,
            runID,
            oetID,
            oet => {
                swal({
                    title: "Successfully updated!",
                    text: `The Base ID was u[dated in OET #${oet.id_zfill}`,
                    icon: "success",
                    timer: 3000,
                    button: true
                });
                runID && dispatch(getRunDetail(runID, oetID));
            },
            errors => alertFailyUpdate(errors)
        );
    };
};

const updateOMC = (oetID, pr_approved_date, history, runID, form = undefined) => {
    return dispatch => {
        if (!pr_approved_date) {
            swal({
                title: "Validation error!",
                text: `The PR approved date is required`,
                icon: "warning",
                timer: 3000,
                button: true
            });
            return;
        }
        const promise = service.updateOET(oetID, { pr_approved_date: pr_approved_date, run: runID });
        updateOETfromPromise(
            promise,
            dispatch,
            history,
            runID,
            oetID,
            oet => {
                swal({
                    title: "Successfully updated!",
                    text: `The PR approved date was u[dated in OET #${oet.id_zfill}`,
                    icon: "success",
                    timer: 3000,
                    button: true
                });
                runID && dispatch(getRunDetail(runID, oetID));
            },
            errors => alertFailyUpdate(errors)
        );
    };
};

const updateFandC = (oetID, body, history, runID) => {
    const {
        sap_customer_name,
        sap_down_payment_contract_number,
        sap_top_wbs,
        quantity_contract_number,
        payment_terms_code,
        customer_payment_terms,
        incoterms,
        sales_order_billing_plan,
        incoterms_code
    } = body;
    return dispatch => {
        const promise = service.updateOET(oetID, {
            sap_customer_name,
            sap_down_payment_contract_number,
            sap_top_wbs,
            quantity_contract_number,
            payment_terms_code,
            customer_payment_terms,
            incoterms,
            sales_order_billing_plan,
            incoterms_code
        });
        updateOETfromPromise(
            promise,
            dispatch,
            history,
            runID,
            oetID,
            oet => {
                alertSuccessfullyUpdate(oet);
                runID && dispatch(getRunDetail(runID, oetID));
            },
            errors => alertFailyUpdate(errors)
        );
    };
};

const updateOETfromPromise = (promise, dispatch, history, runID, oetID, ok = () => {}, err = () => {}) => {
    return Promise.all([promise, service.getRunList(oetID)])
        .then(response => {
            const [oet, runs] = response;
            ok && dispatch(getOetInDetailSuccess({ ...oet, runs }, ok));
        })
        .catch(error => {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        history.push("/inbox");
                        break;
                    case 400:
                        err(error.response.data);
                        break;
                    default:
                        break;
                }
            }
            dispatch(getOetInDetailFail(error));
        });
};

// RUNS
const getRunList = oetID => {
    return dispatch => {
        dispatch({ type: types.GET_RUN_LIST });
        service
            .getRunList(oetID)
            .then(runs => dispatch(getRunListSuccess(runs)))
            .catch(error => dispatch(getRunListFail(error)));
    };
};

const getRunDetail = (runID, oetID, withSSOTI=true) => {
    return dispatch => {
        dispatch({ type: types.GET_RUN_DETAIL });
        return service
            .getRunDetail(runID)
            .then(run => {
                dispatch(getSiteOet(oetID, runID, 1));
                if (withSSOTI) {
                    dispatch(getOetSSOTI(oetID, runID, 1));
                }
                dispatch(getRunDetailSuccess(run));
            })
            .catch(error => dispatch(getRunDetailFail(error)));
    };
};
const createRun = (oet_id, oet_item, history, type_flow, onOk, onFail, data) => {
    return dispatch => {
        dispatch({ type: types.CREATE_RUN });
        service
            .createRun(oet_id, oet_item, type_flow, data)
            .then(run =>{
                dispatch(
                    createRunSuccess(run, () => {
                        onOk && onOk(run);
                        dispatch(getRunList(oet_id));
                        const promise = service.getOetInDetail(run.oet);
                        updateOETfromPromise(promise, dispatch, history, run.id, run.oet);
                    })
                )
            }
            )
            .catch(error => {
                onFail && onFail(error);
                dispatch(createRunFail(error.response));
            });
    };
};

const updateRun = (runID, body, onFail = () => {}, onSuccess = () => {}) => {
    return dispatch => {
        dispatch({ type: types.UPDATE_RUN });
        return service
            .updateRun(runID, body)
            .then(run => {
                dispatch(updateRunSuccess(run));
                return run;
            })
            .catch(error => {
                dispatch(updateRunFail(error.response));
                onFail(error);
                return error;
            });
    };
};

const syncQuantityContract = (oetID, run_id, fn) => {
    return dispatch => {
        dispatch({ type: types.SYNCQUANTITYCONTRACT });
        service
            .syncQuantityContract(run_id)
            .then(result => {
                fn && fn(true, result);
                dispatch(getOetSSOTI(oetID, run_id));
                dispatch({
                    type: types.SYNCQUANTITYCONTRACT_SUCCESS,
                    payload: result
                });
            })
            .catch(error => {
                if (error.response && error.response.status === 400) {
                    fn && fn(false, error.response.data);
                }
                dispatch({
                    type: types.SYNCQUANTITYCONTRACT_FAIL,
                    payload: error
                });
            });
    };
};


const changeQuantityLimit = (oet_id, run_id, fn) => {
    return dispatch => {
        dispatch({type: types.CHANGE_QUANTITY_LIMIT});
        service
            .changeQuantityLimit(run_id)
            .then(result => {
                fn && fn(true, result);
                dispatch({
                    type: types.CHANGE_QUANTITY_LIMIT_SUCCESS,
                    payload: result
                });
            })
            .catch(error => {
                if (error.response && error.response.status === 400) {
                    fn && fn(false, error.response.data);
                }
                dispatch({
                    type: types.CHANGE_QUANTITY_LIMIT_FAIL,
                    payload: error
                });
            });
    };
};

const startPRValidation = (oetID, run_id, pr_validation_id, fn) => {
    return dispatch => {
        dispatch({ type: types.START_PR_VALIDATION });
        service
            .startPRValidation(run_id, pr_validation_id)
            .then(result => {
                fn && fn(true, result);
                dispatch({
                    type: types.START_PR_VALIDATION_SUCCESS,
                    payload: result
                });
            })
            .catch(error => {
                if (error.response && error.response.status === 400) {
                    fn && fn(false, error.response.data);
                }
                dispatch({
                    type: types.START_PR_VALIDATION_FAIL,
                    payload: error
                });
            });
    };
};

const syncWbs = (oetID, run_id, fn) => {
    return dispatch => {
        dispatch({ type: types.SYNCWBS });
        service
            .syncWbs(run_id)
            .then(result => {
                fn && fn(true, result);
                dispatch(getOetSSOTI(oetID, run_id));
                dispatch({
                    type: types.SYNCWBS_SUCCESS,
                    payload: result
                });
            })
            .catch(error => {
                if (error.response && error.response.status === 400) {
                    fn && fn(false, error.response.data);
                }
                dispatch({
                    type: types.SYNCWBS_FAIL,
                    payload: error
                });
            });
    };
};

const syncVoa = (oetID, run_id, fn) => {
    return dispatch => {
        dispatch({ type: types.SYNCVOA });
        service
            .syncVoa(run_id)
            .then(result => {
                fn && fn(true, result);
                dispatch(getOetSSOTI(oetID, run_id));
                dispatch({
                    type: types.SYNCVOA_SUCCESS,
                    payload: result
                });
            })
            .catch(error => {
                if (error.response && error.response.status === 400) {
                    fn && fn(false, error.response.data);
                }
                dispatch({
                    type: types.SYNCVOA_FAIL,
                    payload: error
                });
            });
    };
};

const changeSitesPage = (oetID, runID, page) => {
    return dispatch => {
        dispatch(changeSitesPages({ page: page }));
        dispatch(getSiteOet(oetID, runID));
    };
};

const changeSsotiPage = (oetID, runID, page) => {
    return dispatch => {
        dispatch(changeSsotiPages({ page: page }));
        dispatch(getOetSSOTI(oetID, runID));
    };
};

const getSSOTIOnlyParent = (oetID, runID, page, cancelled, site_ids = null, material_type = null) => {
    return dispatch => {
        dispatch({ type: types.GET_SSOTI_ONLY_PARENT });
        return service
            .getSSOTIOET(oetID, runID, page, cancelled, true, site_ids, material_type)
            .then(result => {
                dispatch(getSSOTIOnlyParentSuccess(result));
                return result;
            })
            .catch(error => {
                dispatch(getSSOTIOnlyParentFail(error));
                return error.response;
            });
    };
};
// -------------------- //
const updateRunSuccess = payload => ({
    type: types.UPDATE_RUN_SUCCESS,
    payload
});
const updateRunFail = payload => ({
    type: types.UPDATE_RUN_FAIL,
    payload
});
const getRunListSuccess = payload => ({
    type: types.GET_RUN_LIST_SUCCESS,
    payload
});
const getRunListFail = payload => ({
    type: types.GET_RUN_LIST_FAIL,
    payload
});
const getRunDetailSuccess = payload => ({
    type: types.GET_RUN_DETAIL_SUCCESS,
    payload
});
const getRunDetailFail = payload => ({
    type: types.GET_RUN_DETAIL_FAIL,
    payload
});
const createRunSuccess = (payload, fn) => {
    fn && fn(payload);
    return {
        type: types.CREATE_RUN_SUCCESS,
        payload
    };
};
const createRunFail = payload => ({
    type: types.CREATE_RUN_FAIL,
    payload
});

const createOetInSuccess = (oet, fn) => {
    fn && fn(oet);
    return {
        type: types.CREATE_OET_IN_SUCCESS,
        payload: oet
    };
};

const createOetInFail = (error, fn = () => {}) => {
    fn(error);
    return {
        type: types.CREATE_OET_IN_FAIL,
        payload: error
    };
};

const getOetInDetailSuccess = (oet, fn) => {
    fn && fn(oet);
    return {
        type: types.GET_OET_IN_DETAIL_SUCCESS,
        payload: oet
    };
};

const getOetInDetailFail = error => {
    return {
        type: types.GET_OET_IN_DETAIL_FAIL,
        payload: error
    };
};

const getSiteOetSuccess = sites => {
    return {
        type: types.GET_SITES_SUCCESS,
        payload: sites
    };
};

const getSiteOetFail = error => {
    return {
        type: types.GET_SITES_FAIL,
        payload: error
    };
};

const getOetSSOTISuccess = ssoti => {
    return {
        type: types.GET_SSOTITEM_SUCCESS,
        payload: ssoti
    };
};

const getOetSSOTIFail = error => {
    return {
        type: types.GET_SSOTITEM_FAIL,
        payload: error
    };
};

const changeSitesPages = payload => ({
    type: types.SITES_CHANGE_PAGE,
    payload
});

const updateSitesPagination = payload => ({
    type: types.SITES_UPDATE_PAGINATION,
    payload
});

const changeSsotiPages = payload => ({
    type: types.SSOTITEM_CHANGE_PAGE,
    payload
});

const updateSsotiPagination = payload => ({
    type: types.SSOTITEM_UPDATE_PAGINATION,
    payload
});

const getSSOTIOnlyParentFail = error => ({
    type: types.GET_SSOTI_ONLY_PARENT_FAIL,
    payload: error
});

const getSSOTIOnlyParentSuccess = result => ({
    type: types.GET_SSOTI_ONLY_PARENT_SUCCESS,
    payload: result
});

export default {
    createOetIn,
    getOetInDetail,
    changeOETStatus,
    updateLogistic,
    updateTCC,
    updateCPM,
    updateOMC,
    updateFandC,
    getSiteOet,
    getOetSSOTI,
    updateOETItem,
    getRunList,
    cancelSsotItems,
    getRunDetail,
    createRun,
    updateRun,
    syncQuantityContract,
    changeQuantityLimit,
    syncWbs,
    syncVoa,
    changeSitesPage,
    changeSsotiPage,
    getSSOTIOnlyParent,
    startPRValidation,
    executeService
};
